import LanguageChange from './LanguageChange'

export default LanguageChange
